import React from "react";

import { StyledSVG } from "../StyledIcon";

export const GlobeIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 60 60"
      fill="none"
      {...props}
    >
      <circle
        cx="30"
        cy="30"
        r="26"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <circle
        cx="30"
        cy="30"
        r="26"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M39.5 6C28 6 39.5141 20.7059 27.3669 20.7059C20.8767 20.7059 18.8797 30.5098 29.3639 30.5098C54.3261 30.5098 47.8359 56 31.8601 56"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M25 54.5C25 51 26 42 20 42C8.48193 42 17.916 24.5 8.50003 24.5C7.03514 24.5 5.95912 23.918 5.1803 23"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </StyledSVG>
  );
};
